export default __webpack_public_path__ + "static/media/BM.8f97d4aa.ico";